import React, { useState } from 'react';
import fImg from '../../images/faq/faq-right-bg.png'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';



const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (

        <section className="faq-section">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 pr-125 rpr-15">
                        <div className="faq-left-image"></div>
                    </div>
                    <div className="col-lg-6 pl-0">
                        <div className="faq-accordion ras-content pt-95 pb-110 rpb-0 rmb-100">
                            <div className="section-title mb-35">
                                <h6>Best Architecture</h6>
                                <h2>Architecture did  expect
                                    <span className="thin">strategist</span>
                                </h2>
                            </div>
                            <div id="accordion">
                                <Accordion open={open} toggle={toggle}>
                                    <AccordionItem className='card'>
                                        <AccordionHeader targetId="1" className='card-header'>Farm Land</AccordionHeader>
                                        <AccordionBody accordionId="1">
                                        Escape the urban hustle and embrace the tranquility of rural living. Whether you're an aspiring farmer, a nature enthusiast, or a savvy investor, farmland presents a world of possibilities
                                        </AccordionBody>
                                    </AccordionItem>
                                    <AccordionItem className='card'>
                                        <AccordionHeader targetId="2" className='card-header'>Villas</AccordionHeader>
                                        <AccordionBody accordionId="2">
                                        Indulge in the epitome of luxury living. Villas offer spacious layouts, private gardens, and world-class amenities. Experience the ultimate in comfort and exclusivity.
                                        </AccordionBody>
                                    </AccordionItem>
                                    <AccordionItem className='card'>
                                        <AccordionHeader targetId="3" className='card-header'>Residencial</AccordionHeader>
                                        <AccordionBody accordionId="3">
                                        Discover your perfect home. From cozy apartments to spacious family houses, find your ideal living space.                                        </AccordionBody>
                                    </AccordionItem>
                                    <AccordionItem className='card'>
                                        <AccordionHeader targetId="4" className='card-header'>Buildings</AccordionHeader>
                                        <AccordionBody accordionId="4">
                                        Discover a world of possibilities with diverse property options. From commercial spaces to industrial complexes, find the perfect building for your needs.                                        </AccordionBody>
                                    </AccordionItem>
                                </Accordion>
                            </div>
                        </div>
                        <div className="faq-right-bg">
                            <img src={fImg} alt="FAQ" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default FaqSection;